var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.userType || _vm.userType === _vm.ANONYMOUS)?_c('home-menu',{attrs:{"pro":_vm.pro}}):_vm._e(),(_vm.userType === _vm.ENDUSER)?_c('enduser-menu'):_vm._e(),(_vm.userType === _vm.SERVICEPROVIDER)?_c('service-provider-menu'):_vm._e(),_c('kdw-Statusbar-card',{ref:"kdwsnackbar"}),_c('common-view'),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }